import Image from "next/image";
import Link from "next/link";

import { awsLoader } from "../../lib/rendering/aws-loader";

type GridItemProps = {
  href: string;
  title: string;
  subtitle?: string;
  imageSrc?: string;
};

function GridItem(props: GridItemProps) {
  return (
    <Link href={props.href}>
      <a className="group text-sm">
        <div className="relative w-full aspect-w-1 aspect-h-1 rounded-lg overflow-hidden bg-gray-100 group-hover:opacity-75">
          {props.imageSrc && (
            <Image
              loader={awsLoader}
              layout="fill"
              src={props.imageSrc}
              alt=""
              className="w-full h-full object-center object-cover"
            />
          )}
        </div>
        <h3 className="mt-4 font-medium text-gray-900">{props.title}</h3>
        {props.subtitle && (
          <p className="text-gray-500 italic">{props.subtitle}</p>
        )}
        {/*<p className="mt-2 font-medium text-gray-900">$500</p>*/}
      </a>
    </Link>
  );
}

export default GridItem;
